import React, { Component, Fragment } from "react";
import {
	Card,
	Spin,
	Row,
	Col,
	Button,
	Form,
	Popconfirm,
	Icon,
	message,
	Upload,
	Input,
	Tabs,
	Slider,
	Checkbox,
	Tooltip
} from "antd";
import { inject, observer } from "mobx-react";
import _ from "lodash";
import co from "co";

const FormItem = Form.Item;
const { TextArea } = Input;

const pType = [
	"primary",
	"secondary",
	"branded",	
	"generic",
	"nakedUrl"
];

const keywordHelp = {
	primary: "More than one keyword is recommended",
	secondary:
		"Keywords related to your primary keywords. \nEx: controlling your dog (Main keyword: dog traning)",
	branded:
		"Brand/Business name. \nEx: John's Dog School. (Main keyword: dog training)",			
	generic: "Anchor text like: click here, learn more",
	nakedUrl: "Use domains/urls as anchor text"
};

@Form.create({
	mapPropsToFields(props) {
		return props.fields;
	},
	onFieldsChange(props, changedFiles) {
		props.onFieldsChange(changedFiles);
	}
})
@observer
class KeywordsForm extends Component {
	validateForm = callback => {
		this.props.form.validateFieldsAndScroll({ force: true }, callback);
	};

	getValues = () => {
		return {
			primaryKeyword: this.props.form.getFieldValue("primaryKeyword"),
			secondaryKeyword: this.props.form.getFieldValue("secondaryKeyword"),
			genericKeyword: this.props.form.getFieldValue("genericKeyword"),
			primaryPercentage: this.props.form.getFieldValue("primaryPercentage"),
			secondaryPercentage: this.props.form.getFieldValue("secondaryPercentage"),
			genericPercentage: this.props.form.getFieldValue("genericPercentage"),
			nakedUrlPercentage: this.props.form.getFieldValue("nakedUrlPercentage")
		};
	};

	secondaryPercentageChange = value => {
		var delta =
			parseInt(value) - this.props.form.getFieldValue("secondaryPercentage");
		var primaryPercentage = this.props.form.getFieldValue("primaryPercentage");
		var genericPercentage = this.props.form.getFieldValue("genericPercentage");
		var nakedUrlPercentage = this.props.form.getFieldValue(
			"nakedUrlPercentage"
		);
		var delta2 = primaryPercentage - delta;

		if (delta2 >= 0) {
			primaryPercentage = delta2;
		} else {
			primaryPercentage = 0;
			var delta3 = genericPercentage + delta2;
			if (delta3 >= 0) {
				genericPercentage = delta3;
			} else {
				genericPercentage = 0;
				nakedUrlPercentage = nakedUrlPercentage + delta3;
			}
		}
		var secondaryPercentage = parseInt(value);

		this.props.form.setFieldsValue({
			primaryPercentage: primaryPercentage,
			secondaryPercentage: secondaryPercentage,
			genericPercentage: genericPercentage,
			nakedUrlPercentage: nakedUrlPercentage
		});
		this.props.form.validateFields({ force: true });
	};

	genericPercentageChange = value => {
		var delta =
			parseInt(value) - this.props.form.getFieldValue("genericPercentage");
		var primaryPercentage = this.props.form.getFieldValue("primaryPercentage");
		var secondaryPercentage = this.props.form.getFieldValue(
			"secondaryPercentage"
		);
		var nakedUrlPercentage = this.props.form.getFieldValue(
			"nakedUrlPercentage"
		);
		var delta2 = primaryPercentage - delta;

		if (delta2 >= 0) {
			primaryPercentage = delta2;
		} else {
			primaryPercentage = 0;
			var delta3 = secondaryPercentage + delta2;
			if (delta3 >= 0) {
				secondaryPercentage = delta3;
			} else {
				secondaryPercentage = 0;
				nakedUrlPercentage = nakedUrlPercentage + delta3;
			}
		}
		var genericPercentage = parseInt(value);
		this.props.form.setFieldsValue({
			primaryPercentage: primaryPercentage,
			secondaryPercentage: secondaryPercentage,
			genericPercentage: genericPercentage,
			nakedUrlPercentage: nakedUrlPercentage
		});
		this.props.form.validateFields({ force: true });
	};

	nakedPercentageChange = value => {
		var delta =
			parseInt(value) - this.props.form.getFieldValue("nakedUrlPercentage");
		var primaryPercentage = this.props.form.getFieldValue("primaryPercentage");
		var secondaryPercentage = this.props.form.getFieldValue(
			"secondaryPercentage"
		);
		var genericPercentage = this.props.form.getFieldValue("genericPercentage");
		var delta2 = primaryPercentage - delta;

		if (delta2 >= 0) {
			primaryPercentage = delta2;
		} else {
			primaryPercentage = 0;
			var delta3 = secondaryPercentage + delta2;
			if (delta3 >= 0) {
				secondaryPercentage = delta3;
			} else {
				secondaryPercentage = 0;
				genericPercentage = genericPercentage + delta3;
			}
		}
		var nakedUrlPercentage = parseInt(value);
		this.props.form.setFieldsValue({
			primaryPercentage: primaryPercentage,
			secondaryPercentage: secondaryPercentage,
			genericPercentage: genericPercentage,
			nakedUrlPercentage: nakedUrlPercentage
		});
		this.props.form.validateFields({ force: true });
	};

	keywordValidator = (rule, value, callback) => {
		// console.log("Validating keyword");
		if (!rule.field) {
			callback();
			return;
		}

		let tmp = rule.field.split(".");
		let type = tmp[tmp.length - 1].replace("Keyword", "");

		if (!value) {
			const tier = this.props.tier;
			if (
				this.props.form.getFieldValue(
					`${type}Percentage`
				) != 0
			) {
				let cType = _.capitalize(type);
				callback(cType + " keyword is required");
				return;
			}
		}

		callback();
	};

	renderKeywordAndPercentage = type => {
		const tier = this.props.tier;
		let cType = _.capitalize(type);

		if (type == "primary") {
			return (
				<Col span={6} key={type}>
					<FormItem
						label={
							<span>
								{cType +
									" Keywords - " +
									this.props.form.getFieldValue(`${type}Percentage`) +
									"%"}
								{'  '}
								<Tooltip title={keywordHelp[type]}>
									<Icon
										type="question-circle"
										theme="twoTone"
										// style={{ fontSize: "22px" }}
									/>
								</Tooltip>
							</span>
						}
						colon={false}
						style={{ marginBottom: 10 }}
					>
						{this.props.form.getFieldDecorator(`primaryPercentage`, {
							rules: [
								{
									type: "integer",
									min: 1,
									message: "Primary percentage must be greater than zero"
								}
							]
						})(<Slider disabled={true} />)}
					</FormItem>
					<FormItem>
						{this.props.form.getFieldDecorator(`primaryKeyword`, {
							rules: [
								{ required: true, message: "Primary keyword is required" }
							]
						})(
							<TextArea
								style={{ fontFamily: "Arial", resize: "none" }}
								rows={3}
								autoComplete="off"
								autoCorrect="off"
								autoCapitalize="off"
								spellCheck="false"
							/>
						)}
					</FormItem>
				</Col>
			);
		}

		if (type == "nakedUrl") {
			return (
				<Col span={6} key={type}>
					<FormItem
						label={
							<span>
								{"Naked URL - " +
									this.props.form.getFieldValue(`nakedUrlPercentage`) +
									"%"}
								{'  '}
								<Tooltip title={keywordHelp[type]}>
									<Icon
										type="question-circle"
										theme="twoTone"
										// style={{ fontSize: "22px" }}
									/>
								</Tooltip>
							</span>
						}
						colon={false}
						style={{ marginBottom: 10 }}
					>
						{this.props.form.getFieldDecorator(`nakedUrlPercentage`)(
							<Slider />
						)}
					</FormItem>
				</Col>
			);
		}

		return (
			<Col span={6} key={type}>
				<FormItem
					label={
						<span>
							{cType +
								" Keywords - " +
								this.props.form.getFieldValue(`${type}Percentage`) +
								"%"}
							{'  '}
							<Tooltip title={keywordHelp[type]}>
								<Icon
									type="question-circle"
									theme="twoTone"
									// style={{ fontSize: "22px" }}
								/>
							</Tooltip>
						</span>
					}
					colon={false}
					style={{ marginBottom: 10 }}
				>
					{this.props.form.getFieldDecorator(`${type}Percentage`)(<Slider />)}
				</FormItem>
				<FormItem>
					{this.props.form.getFieldDecorator(
						`${type}Keyword`,
						{
							rules: [
								{
									validator: this.keywordValidator
								}
							]
						}
					)(
						<TextArea
							style={{ fontFamily: "Arial", resize: "none" }}
							rows={3}
							autoComplete="off"
							autoCorrect="off"
							autoCapitalize="off"
							spellCheck="false"
						/>
					)}
				</FormItem>
			</Col>
		);
	};

	render() {
		const secondaryKeywordRequired =
			this.props.form.getFieldValue("secondaryPercentage") > 0;

		let secondaryKeywordValidator = (rule, value, callback) => {
			if (!value) {
				if (this.props.form.getFieldValue("secondaryPercentage") != 0) {
					callback("Secondary keyword is required");
					return;
				}
			}

			callback();
		};

		let genericKeywordValidator = (rule, value, callback) => {
			if (!value) {
				if (this.props.form.getFieldValue("genericPercentage") != 0) {
					callback("Generic keyword is required");
					return;
				}
			}

			callback();
		};

		return (
			<Form layout="vertical">
				<Row>
					<FormItem>
						{this.props.form.getFieldDecorator("useKeyword", {
							valuePropName: "checked"
						})(<Checkbox>Use Keywords as Anchor Text</Checkbox>)}
					</FormItem>
				</Row>
				{this.props.form.getFieldValue("useKeyword") && (
					<Row gutter={8}>
						{pType.map(type => {
							return this.renderKeywordAndPercentage(type);
						})}
					</Row>
					// <Row gutter={8}>
					// 	<Col span={6}>
					// 		<FormItem
					// 			label={
					// 				"Primary: " +
					// 				this.props.form.getFieldValue("primaryPercentage") +
					// 				"%"
					// 			}
					// 			style={{ marginBottom: 10 }}
					// 		>
					// 			{this.props.form.getFieldDecorator("primaryPercentage", {
					// 				rules: [
					// 					{
					// 						type: "integer",
					// 						min: 1,
					// 						message: "Primary percentage must be greater than zero"
					// 					}
					// 				]
					// 			})(<Slider disabled={true} />)}
					// 		</FormItem>
					// 		<FormItem>
					// 			{this.props.form.getFieldDecorator("primaryKeyword", {
					// 				rules: [
					// 					{ required: true, message: "Primary keyword is required" }
					// 				]
					// 			})(
					// 				<TextArea
					// 					style={{ height: 100, resize: "none" }}
					// 					autoComplete="off"
					// 					autoCorrect="off"
					// 					autoCapitalize="off"
					// 					spellCheck="false"
					// 				/>
					// 			)}
					// 		</FormItem>
					// 	</Col>
					// 	<Col span={6}>
					// 		<FormItem
					// 			label={
					// 				"Secondary: " +
					// 				this.props.form.getFieldValue("secondaryPercentage") +
					// 				"%"
					// 			}
					// 			style={{ marginBottom: 10 }}
					// 		>
					// 			{this.props.form.getFieldDecorator("secondaryPercentage")(
					// 				<Slider onChange={this.secondaryPercentageChange} />
					// 			)}
					// 		</FormItem>
					// 		<FormItem>
					// 			{this.props.form.getFieldDecorator("secondaryKeyword", {
					// 				rules: [
					// 					{
					// 						validator: secondaryKeywordValidator
					// 					}
					// 				]
					// 			})(
					// 				<TextArea
					// 					style={{ height: 100, resize: "none" }}
					// 					autoComplete="off"
					// 					autoCorrect="off"
					// 					autoCapitalize="off"
					// 					spellCheck="false"
					// 				/>
					// 			)}
					// 		</FormItem>
					// 	</Col>
					// 	<Col span={6}>
					// 		<FormItem
					// 			label={
					// 				"Generic: " +
					// 				this.props.form.getFieldValue("genericPercentage") +
					// 				"%"
					// 			}
					// 			style={{ marginBottom: 10 }}
					// 		>
					// 			{this.props.form.getFieldDecorator("genericPercentage")(
					// 				<Slider onChange={this.genericPercentageChange} />
					// 			)}
					// 		</FormItem>
					// 		<FormItem>
					// 			{this.props.form.getFieldDecorator("genericKeyword", {
					// 				rules: [{ validator: genericKeywordValidator }]
					// 			})(
					// 				<TextArea
					// 					style={{ height: 100, resize: "none" }}
					// 					autoComplete="off"
					// 					autoCorrect="off"
					// 					autoCapitalize="off"
					// 					spellCheck="false"
					// 				/>
					// 			)}
					// 		</FormItem>
					// 	</Col>
					// 	<Col span={6}>
					// 		<FormItem
					// 			label={
					// 				"Naked URL: " +
					// 				this.props.form.getFieldValue("nakedUrlPercentage") +
					// 				"%"
					// 			}
					// 			style={{ marginBottom: 10 }}
					// 		>
					// 			{this.props.form.getFieldDecorator("nakedUrlPercentage")(
					// 				<Slider onChange={this.nakedPercentageChange} />
					// 			)}
					// 		</FormItem>
					// 	</Col>
					// </Row>
				)}
			</Form>
		);
	}
}

@inject("rootStore")
@observer
class KeywordsTab extends Component {
	validateForm = () => {
		return new Promise(resolve => {
			this.internalForm.validateForm((err, vals) => {
				resolve(err);
			});
		});
	};

	onFieldsChange = changedFields => {
		const {
			rootStore: { linksStore }
		} = this.props;

		linksStore.keywordsFormChanged(changedFields);
	};

	saveKeywords = () => {
		const {
			rootStore: { linksStore }
		} = this.props;
		co(
			function*() {
				const response = yield this.validateForm();
				// console.log("Response", response);
				if (response != null) {
					// console.log(response);
					return;
				}
				linksStore.remoteSaveLinkSetKeywords(this.internalForm.getValues());
			}.bind(this)
		);
	};

	mapPropsToFields = () => {
		const {
			rootStore: { linksStore }
		} = this.props;

		return {
			useKeyword: Form.createFormField(linksStore.urlListForm.useKeyword),
			primaryKeyword: Form.createFormField(linksStore.urlListForm.primaryKeyword),
			secondaryKeyword: Form.createFormField(linksStore.urlListForm.secondaryKeyword),
			brandedKeyword: Form.createFormField(linksStore.urlListForm.brandedKeyword),			
			genericKeyword: Form.createFormField(linksStore.urlListForm.genericKeyword),
			primaryPercentage: Form.createFormField(
				linksStore.urlListForm.primaryPercentage
			),
			secondaryPercentage: Form.createFormField(
				linksStore.urlListForm.secondaryPercentage
			),
			brandedPercentage: Form.createFormField(
				linksStore.urlListForm.brandedPercentage
			),		
			genericPercentage: Form.createFormField(
				linksStore.urlListForm.genericPercentage
			),
			nakedUrlPercentage: Form.createFormField(
				linksStore.urlListForm.nakedUrlPercentage
			)
		};
	};
	render() {
		const {
			rootStore: { linksStore }
		} = this.props;

		const ui = linksStore.ui;
		const spinning = ui.savingLinkSetKeywords == true;
		return (
			<Fragment>
				<Spin spinning={spinning}>
					<KeywordsForm
						fields={this.mapPropsToFields()}
						onFieldsChange={this.onFieldsChange}
						wrappedComponentRef={internalForm => {
							this.internalForm = internalForm;
						}}
					/>
				</Spin>
				<Row>
					<Button
						type="primary"
						onClick={this.saveKeywords}
						loading={ui.saveLinkSetKeywords}
					>
						Save
					</Button>
				</Row>
			</Fragment>
		);
	}
}

export default KeywordsTab;
